import clsx from 'clsx';
import type { Transactie } from '../../stores/kas-store';

interface TransactieRijProps {
  transactie: Transactie;
}

function formatTime(dateStr: string): string {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
}

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(amount);
}

export function TransactieRij({ transactie }: TransactieRijProps) {
  return (
    <div className="flex items-center gap-3 py-2 px-3 text-sm border-b border-gray-50 last:border-b-0">
      {/* Status indicator */}
      <div className={clsx(
        'w-2 h-2 rounded-full flex-shrink-0',
        transactie.gecontroleerd ? 'bg-green-500' : 'bg-amber-400'
      )} />

      {/* Werk Order */}
      <span className="text-muted min-w-[90px]">
        {transactie.werkOrderNaam || '-'}
      </span>

      {/* Bedrag */}
      <span className="font-medium text-main min-w-[80px]">
        {formatCurrency(transactie.bedrag)}
      </span>

      {/* Tijdstip */}
      <span className="text-muted min-w-[50px]">
        {formatTime(transactie.datumTijdOntvangen)}
      </span>

      {/* Opmerking */}
      <span className="text-muted truncate flex-1 text-xs">
        {transactie.opmerkingen || ''}
      </span>
    </div>
  );
}
